import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';

import CallIcon from '@material-ui/icons/CallOutlined';

import CalloutBase from './Base';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.primary.main
  },
  shareSection: { backgroundColor: '#0083EC' },
  printAction: {
    '&:hover': {
      '& > span': {
        color: '#0097eb'
      }
    }
  },
  printActionLabel: {
    color: theme.palette.primary.main
  }
});

export const NeedsMoreSteps = ({
  t,
  classes,
  printBOL,
  printLabels,
  sendDocs
}) => (
  <CalloutBase
    icon={CallIcon}
    title={t('Contact carrier to tender shipment.')}
    message={t('Your shipment was saved, but needs to be tendered.')}
    printBOL={printBOL}
    printLabels={printLabels}
    sendDocs={sendDocs}
    classes={{
      root: classes.root,
      shareSection: classes.shareSection,
      printAction: classes.printAction,
      printActionLabel: classes.printActionLabel
    }}
  />
);

export default withStyles(styles)(withNamespaces()(NeedsMoreSteps));
